var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroShapeBottomRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 339,
    height: 662,
    viewBox: "1102 412 339 662",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440.5 412C1193.3 592.4 1111.83 928.5 1102 1074H1440.5V412Z",
    fill: "url(#paint2_linear_2830_3990)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.5 1073C1156.61 761.45 1345.18 688.562 1440.96 691.061V1073H1168.5Z",
    fill: "url(#paint3_linear_2830_3990)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2830_3990",
    x1: 1271.25,
    y1: 412,
    x2: 1271.25,
    y2: 1074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2830_3990",
    x1: 1304.46,
    y1: 691,
    x2: 1304.46,
    y2: 1073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroShapeBottomRight);
export default __webpack_public_path__ + "static/media/hero-shape-bottom-right.8eb3e26ab1e799f209f6935b0ecae543.svg";
export { ForwardRef as ReactComponent };